import script from "./CampaignStatusBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./CampaignStatusBadge.vue?vue&type=script&setup=true&lang=js"

import "./CampaignStatusBadge.vue?vue&type=style&index=0&id=516c37c5&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-516c37c5"]])

export default __exports__